/**
 * 악덕 테스트 통화 모달 — 관리자 악덕마스터/악덕신고 페이지 공용.
 *
 *   $j.F.Admin.Devil.TestCall.open({ labels: DV_MASTER_STATUS, onDone: reloadTable });
 *
 * 발신 회원이 대상 악덕과 통화한 것으로 /api/devil/call/update 를 호출하고,
 * 공유여부를 고르면 통화 직후 /api/devil/call/share 로 g5_dv_share_prefs 결정을 기록한다.
 * (둘 다 G5_API — uid/mb_no 파라미터로 식별. 자동완성은 /adm/ajax/devil/call/* 사용)
 *
 *  - 대상 악덕 : 전화/업체명 자동완성 → phone + master_num 저장
 *  - 발신 회원 : 회원번호/이름 자동완성 → mem_phone(uid) + mb_no 저장
 *  - 공유여부  : '설정 안 함' | '공유' | '비공유' (공유설정엔 master_num·mb_no 둘 다 선택 필요)
 */
import Util from '../../../Common/Util';
export default class TestCall {
    constructor() {
        this.modalId = 'devil-test-call';
        this.labels  = {};   // 악덕 상태 라벨맵(G5_DV_MASTER_STATUS) — 배지 표기용
        this.onDone  = null; // 성공 후 콜백(목록 새로고침 등)
    }

    open = (opts = {}) => {
        this.labels = opts.labels || window.DV_MASTER_STATUS || {};
        this.onDone = (typeof opts.onDone === 'function') ? opts.onDone : null;

        const html = `
            <div style="font-size:13px">
                <div class="form-group" style="position:relative">
                    <label class="small mb-1">악덕 전화 (대상) — 전화/업체명 검색</label>
                    <input id="tc-target" class="form-control form-control-sm" placeholder="전화번호 또는 업체명" autocomplete="off">
                </div>
                <div class="form-group" style="position:relative">
                    <label class="small mb-1">발신 회원 — 회원번호/이름 검색</label>
                    <input id="tc-uid" class="form-control form-control-sm" placeholder="회원번호 또는 이름" autocomplete="off">
                </div>
                <div style="display:flex;gap:10px">
                    <div class="form-group" style="flex:1">
                        <label class="small mb-1">통화시간(초)</label>
                        <input id="tc-dur" class="form-control form-control-sm" value="30" inputmode="numeric">
                    </div>
                    <div class="form-group" style="flex:1">
                        <label class="small mb-1">통화구분</label>
                        <select id="tc-type" class="form-control form-control-sm">
                            <option value="2">발신</option>
                            <option value="1">수신</option>
                            <option value="3">부재중</option>
                        </select>
                    </div>
                    <div class="form-group" style="flex:1">
                        <label class="small mb-1">공유여부</label>
                        <select id="tc-share" class="form-control form-control-sm">
                            <option value="">미설정 (공유결정 안 함)</option>
                            <option value="1">공유함 (is_shared=1)</option>
                            <option value="0">공유 안 함 (is_shared=0)</option>
                        </select>
                    </div>
                </div>
                <p class="text-muted mb-0" style="font-size:11px;line-height:1.5">
                    발신 회원이 위 악덕 전화와 통화한 것으로 <b>/api/devil/call/update</b> 를 호출합니다.
                    20초 초과 + 등록(REG) 악덕이면 통화목록·call_cnt 에 반영됩니다(후처리는 큐 위임).
                    공유여부를 고르면 통화 직후 <b>/api/devil/call/share</b> 로 g5_dv_share_prefs 에 결정을 기록합니다(악덕·회원을 목록에서 선택해야 함).
                </p>
                <div class="dv-modal-actions">
                    <button id="tc-run" class="btn btn-primary btn-sm">통화 실행</button>
                </div>
            </div>`;
        $j.Ui.JBModal.html(this.modalId, html, '테스트 통화', { width: '460px' });

        // 대상(악덕) 자동완성 — 선택 시 phone + master_num 저장(공유설정에 master_num 필요)
        this._bindAc('tc-target', '/adm/ajax/devil/call/master-search',
            r => `${this._esc(r.co_name || '-')} <b>${Util.phoneNumber(r.phone)}</b>`
                + ` <span class="badge-status badge-${r.status}" style="font-size:9px">${this._esc(this.labels[r.status] || r.status)}</span>`,
            r => ({ text: `${(r.co_name || '')} ${Util.phoneNumber(r.phone)}`.trim(), phone: r.phone, master_num: r.master_num }));

        // 발신 회원 자동완성 — 선택 시 phone(uid) + mb_no 저장(공유설정에 mb_no 필요)
        this._bindAc('tc-uid', '/adm/ajax/devil/call/member-search',
            r => `#${r.num} ${this._esc(r.mem_name || '')} <b>${this._esc(r.mem_phone || '')}</b>`,
            r => ({ text: `#${r.num} ${r.mem_name || ''} (${r.mem_phone || ''})`, phone: r.mem_phone, mb_no: r.num }));

        // 실행 버튼 (모듈 캡슐화 — 인라인 onclick 대신 바인딩)
        $(document).off('click.tcrun').on('click.tcrun', '#tc-run', () => this.run());
    }

    // 가벼운 자동완성 — 공용 헬퍼(키보드 ↓/↑/Enter/Esc 지원) 사용. picker(row) → {text, phone, …} 를 data('pick') 에 저장.
    _bindAc = (id, url, renderItem, picker) => {
        const $in = $('#' + id);
        $in.on('input', () => $in.data('pick', null)); // 입력 변경 시 이전 선택 해제
        $j.F.Admin.Util.autocomplete($in, {
            url,
            render: renderItem,
            pick: (r) => { const p = picker(r); $in.val(p.text).data('pick', p); },
        });
    }

    run = () => {
        const tPick = $('#tc-target').data('pick') || null;
        const uPick = $('#tc-uid').data('pick') || null;

        // 대상: 선택값(phone) 우선, 없으면 직접 입력한 번호의 숫자만
        const target = (((tPick && tPick.phone) || $('#tc-target').val() || '') + '').replace(/[^0-9]/g, '');
        // 발신 회원: 선택값(uid=mem_phone) 우선, 없으면 직접 입력이 전화(10자리+)면 그대로 사용
        let uid = (uPick && uPick.phone) ? String(uPick.phone).trim() : '';
        if (!uid) {
            const d = (($('#tc-uid').val() || '') + '').replace(/[^0-9]/g, '');
            if (d.length >= 10) uid = d;
        }
        const dur   = parseInt($('#tc-dur').val(), 10) || 0;
        const type  = parseInt($('#tc-type').val(), 10) || 2;
        const share = $('#tc-share').val();   // '' 설정안함 | '1' 공유 | '0' 비공유

        if (!target) { Util.swalert('대상(악덕)을 검색해 선택하세요.'); return; }
        if (!uid)    { Util.swalert('발신 회원을 검색해 선택하세요.'); return; }

        // 공유여부 설정은 master_num + mb_no 가 필요 → 둘 다 자동완성에서 선택해야 함
        const masterNum = tPick && tPick.master_num;
        const mbNo      = uPick && uPick.mb_no;
        if (share !== '' && (!masterNum || !mbNo)) {
            Util.swalert('공유여부를 설정하려면 악덕과 발신 회원을 자동완성 목록에서 선택하세요.');
            return;
        }

        const $btn = $('#tc-run').prop('disabled', true).text('처리 중…');

        $.ajax({
            url: '/api/devil/call/update',
            type: 'POST',
            contentType: 'application/json',
            // dateTimeMillis 는 서버가 date(…, 초)로 쓰므로 '초' 단위로 보낸다(이름과 달리 초).
            data: JSON.stringify({
                uid: uid,
                type: null,   // 완료 통화(ongoing 아님)
                callLogs: [{
                    number: target,
                    dateTimeMillis: Math.floor(Date.now() / 1000),
                    callType: type,
                    name: '',
                    duration: dur,
                }],
            }),
        }).done(res => {
            const n = res && res.processed != null ? ` (${res.processed}건)` : '';
            const finish = (extra) => {
                $j.Ui.JBModal.close && $j.Ui.JBModal.close(this.modalId);
                const msg = '통화 처리 완료' + n + (extra || '');
                $j.Ui.Toast.show(msg, { type: 'success' });
                if (this.onDone) this.onDone();
            };
            if (share === '') { finish(); return; }
            // 통화 직후 공유여부 결정 기록(g5_dv_share_prefs)
            $.ajax({
                url: '/api/devil/call/share',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ mb_no: mbNo, master_num: masterNum, is_shared: share === '1' }),
            }).done(sr => finish(sr && sr.result ? ` · ${share === '1' ? '공유함' : '공유 안 함'}(is_shared=${share === '1' ? 1 : 0})` : ' · 공유설정 실패'))
              .fail(() => finish(' · 공유설정 실패'));
        }).fail(xhr => {
            const msg = (xhr.responseJSON && xhr.responseJSON.message) || '통화 처리 실패';
            Util.swalert(msg);
            $btn.prop('disabled', false).text('통화 실행');
        });
    }

    _esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
